import { z } from 'zod';

// Behörde (#1208) – eigene Entität neben Court, gleiche Adress-Struktur.
export const authoritySchema = z.object({
  idAuthority: z.number().default(-1),
  Authority: z.string().default(''),
  idFederalState: z.number().default(4),
  FederalState: z.string().default('Brandenburg'),
  Street: z
    .string()
    .nullable()
    .transform(val => val ?? '')
    .default(''),
  StreetNr: z
    .string()
    .nullable()
    .transform(val => val ?? '')
    .default(''),
  Authority_Email: z
    .string()
    .nullable()
    .transform(val => val ?? '')
    .default(''),
  activeAuthority: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(false),
  StreetAditional: z.string().nullable().optional(),
  PhoneNumber: z.string().nullable().optional(),
  Website: z.string().nullable().optional(),
  idPostcode: z.number().nullable().optional(),
  // Aus Relationen
  Postcode: z.string().optional(),
});

export type IAuthority = z.infer<typeof authoritySchema>;
